import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function Protected({ children }: { children: JSX.Element }) {
  const { loading, user } = useAuth();
  const [onboardingCheck, setOnboardingCheck] = useState<'loading' | 'complete' | 'incomplete'>('loading');

  useEffect(() => {
    if (!user) {
      setOnboardingCheck('complete');
      return;
    }
    
    (async () => {
      const { data } = await supabase
        .from('profiles')
        .select('terms_accepted_at')
        .eq('id', user.id)
        .single();
      
      setOnboardingCheck(data?.terms_accepted_at ? 'complete' : 'incomplete');
    })();
  }, [user]);
  
  if (loading || onboardingCheck === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'hsl(var(--bg-app))' }}>
        <div className="text-ivory/60">Loading...</div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/signin" replace />;
  
  if (onboardingCheck === 'incomplete') return <Navigate to="/welcome" replace />;
  
  return children;
}
